/**
 * List of known extension keys for the category
 */ export var CategoryDefinitionExtensionKeys = /*#__PURE__*/ function(CategoryDefinitionExtensionKeys) {
    /** Category formatting for the label */ CategoryDefinitionExtensionKeys["categoryFormatting"] = "categoryFormatting";
    return CategoryDefinitionExtensionKeys;
}({});
